import { ParticipantTabType } from "../../types/MyDataHelps";
import { encodeUrlBase64 } from "./base64UrlEncode";

export function getViewForTab(tabType: ParticipantTabType, tabProperties: { [key: string]: string }, query?: string) {
    if (tabType === "Dashboard") {
        return { type: "Dashboard", dashboardKey: tabProperties["DashboardKey"], patientID: tabProperties["PatientID"] };
    }
    if (tabType === "Tasks") {
        return { type: "Tasks", patientID: tabProperties["PatientID"] };
    }
    if (tabType === "NewsFeed") {
        return { type: "NewsFeed", drilldownDashboardKey: tabProperties["DrilldownDashboardKey"] };
    }
    if (tabType === "Share") {
        return { type: "Share", drilldownDashboardKey: tabProperties["DrilldownDashboardKey"] };
    }
    if (tabType === "ExternalApplication") {
        var externalAppUrl = tabProperties["Url"];
        if (query) {
            if (externalAppUrl.indexOf('?') >= 0) {
                externalAppUrl = externalAppUrl + '&' + query.substr(1);
            }
            else {
                externalAppUrl = externalAppUrl + query;
            }
        }
        return { type: "ExternalApplication", url: externalAppUrl, patientID: tabProperties["PatientID"] };
    }
};

export function getUrlEncodedViewForTab(tabType: ParticipantTabType, tabProperties: { [key: string]: string }, sessionID: string, query?: string) {
    return encodeUrlBase64(getViewForTab(tabType, tabProperties, query), sessionID);
};